import { Component, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { ResourceProvider } from '../../providers/resource/resource';
import { FormControlProvider } from '../../providers/formbuilder/formcontrol';
import { Validators, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LoggerProvider, LoggerEvent } from '../../providers/logger/logger';
import { LoadingProvider } from '../../providers/loading/loading';
import { PATTERNS } from '../../providers/myria/app-variables';
import { TranslateService } from '@ngx-translate/core';
import { StorageProvider } from '../../providers/storage/storage';
import { StorageType } from '../../model/types/storage-type';
import { BiometricsType } from '../../model/types/biometrics-type';
import { AuthProvider } from '../../providers/authorization/auth';
import { Country } from '../../model/myria/app/country';
import { RmtPopupComponent } from '../rmt-popup/rmt-popup';
import { RouteProvider } from '../../providers/route/route';
import * as libphonenumber from 'google-libphonenumber';
import { regions } from '../../environment/region/regions';

import { Platform } from 'ionic-angular';
import { KeyboardProvider } from '../../providers/keyboard/keyboard';
import { UtilsProvider } from '../../providers/myria/utils-provider';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { APP_CONFIG, Region } from '../../environment';
import { PhoneProvider } from '../../providers/phone/phone';
import { RegisterProvider } from '../../providers/register/register';
import { LoginProvider } from '../../providers/myria/login-provider';


@Component({
  selector: 'rmt-login',
  templateUrl: 'rmt-login.html',
  animations: [
    trigger('toggleDiv', [
      state('collapsed', style({ height: '0', opacity: 0 })),
      state('expanded', style({ height: '*', opacity: 1 })),
      transition('collapsed <=> expanded', animate('300ms ease')),
    ])
  ]
})
export class RmtLoginComponent {
  @ViewChild('input') input;
  @ViewChild('select') select;
  @ViewChild('newInputField') newInputField;
  @ViewChild('newInputPhone') newInputPhone;
  @ViewChild('inputCountry') inputCountry;
  @Output() ionChange = new EventEmitter<any>();
  @Output() ionBlur = new EventEmitter<any>();
  @Output() biometrics = new EventEmitter<any>();
  @Output() animatePassword = new EventEmitter<any>();
  @Input() loginId:string;
  @Input() autoAdjustPhoneNumber = false;
  @Input() isPhoneOnly = false;
  @Input() disableCountry: boolean = false;  
  @Input() phoneLabel: string = this.translate.instant('form.customerProfileForm.mobilePhone.label');
  @Input() isSignin: boolean = false;
  @Input() lazyValidationEnabled: boolean = false;
  @Input() phoneCountryCode: number;
  @Input() autoCompleteName="username";
  @Input() inputType="email";
  @Input() showLoaderOnInit: boolean = false;

  formGroup: FormGroup;
  hasPhoneNumber: boolean = false;  
  phoneLibNumberError = false;
  params;
  selectedCountry;
  phone;
  changeTimeout;
  phoneCountriesPromise;
  countries = [];

  @Input() showBiometrics: boolean = false;
  biometricsEnabled: boolean = false;
  isFaceIdEnabled: boolean = false;
  hideError: boolean = false;
  pendingBiometrics: boolean = false;
  inputTitle: string = this.translate.instant('form.signInForm.phoneEmail.label');
  changeValueCallback;


  //
  setDefault: boolean = true;
  selectedCountryPrefix;
  formDisableCountry: boolean = false;
  lastValue;
  isNumberValidating: boolean = false;
  autocomplete;
  showErrorOfBlur: boolean = false;
  phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
  //
  constructor(private resourceProvider: ResourceProvider,
              private formBuilder: FormBuilder,
              private translate: TranslateService,
              private loadingProvider: LoadingProvider,
              private platform: Platform,
              public formProvider: FormControlProvider,
              public storageProvider: StorageProvider,
              public authProvider: AuthProvider,
              private keyboard: KeyboardProvider,
              private routeProvider: RouteProvider,
              private phoneProvider: PhoneProvider,
              private registerProvider: RegisterProvider,
              private loginProvider: LoginProvider,
              private utils: UtilsProvider) {

    // this.params = {
    //   title: this.translate.instant('form.supportedCountriesForm.supportedCountries.required'),
    //   placeholder: this.translate.instant('page.languagePage.countrySearch'),
    //   useIcons: true,
    //   itemFieldIcon: 'category',
    //   itemFieldIconPrefix: 'custom-icon-country-',
    //   itemFieldSelectedText: 'category',
    //   itemFieldValue: 'category',
    //   itemsPromise: this.formProvider.getPhoneNumberCountriesRegistration()
    // };
    this.phoneCountriesPromise = this.formProvider.getPhoneNumberCountriesRegistration();
    this.initParams();
    this.formGroup = this.formBuilder.group({
      input: ['', Validators.compose([Validators.required, (control: FormControl) => {
        let pattern: any = PATTERNS.EMAIL;
        if (this.hasPhoneNumber)
          pattern = PATTERNS.PHONE.toString();
        const error = Validators.pattern(pattern)(control);
        if (error)
          return error;
        return Validators.required(control);
      }])],
      phoneNumberCountry: ['', (control: FormControl) => {
        if (this.hasPhoneNumber)
          return Validators.required(control);
        return null;
      }],
    });
    this.changeValueCallback = (ev) => this.changeValue(ev);
    this.initCountries();
  }

  ngOnInit() {
    this.isBiometricsEnabled();
  }

  setPhoneOnly() {
    this.hasPhoneNumber = true;
    this.hideError = true;
    this.inputTitle = this.translate.instant('page.hubPage.phoneLabel');
    this.resetFormValidationForInput();
    this.formGroup.get('input') && this.formGroup.get('input').markAsPristine();
  }

  async isBiometricsEnabled() {
    if(this.showBiometrics) {
      if (!this.platform.is('cordova')) {
        this.biometricsEnabled = true;
        return;
      }
      try {
        const deviceToken = await this.storageProvider.get(StorageType.FingerprintDeviceToken);
        const available = await this.authProvider.biometricsAvailable();
        if (deviceToken && deviceToken.length > 0 && available) {
          this.biometricsEnabled = true;
          const biometricsMethod = this.authProvider.getBiometricsType();
          this.isFaceIdEnabled = biometricsMethod == BiometricsType.FaceId;
        }
      } catch(ex) {
        LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to check biometrics in login page');
      }
    }
  }

  // async initCountries() {
  //   const allCountries = await this.formProvider.getPhoneNumberCountriesRegistration();
  //   this.params.items = allCountries
  //   this.params.itemsPromise = null;
  // }

  async ngAfterViewInit() {
    if(this.hasPhoneNumber){
      const isoCode = this.utils.mapPhoneCountryCode(this.phoneCountryCode)
      this.newInputField.select.setValue(isoCode);
      this.select.setValue(APP_CONFIG.region.defaultCountryFrom);
    }
    this.ngAfterViewInitPhone()
  }

  async getValue(showLoading: boolean = true) {
    let value = (this.hasPhoneNumber || this.isPhoneOnly) && this.phone ? this.phone : this.newInputField.formControl.value;
    if (this.hasPhoneNumber) {
      if (showLoading)
        this.loadingProvider.showDelayed();
      if(!this.selectedCountry && this.formGroup && this.formGroup.controls.phoneNumberCountry)
        this.selectedCountry = this.formGroup.controls.phoneNumberCountry.value;

      const phoneCountry = await this.getPhoneCountry(this.selectedCountry);
      if (showLoading)
        this.loadingProvider.hide();

      if (!phoneCountry)
        return null;
      value = phoneCountry.value + '-' + value; // the - will be removed in signin
    }
    return value;
  }

  async getPhoneCountry(country, countryValue = null) {
    let countries = null;
    let countriesex = null;
    try {
      countries = await this.phoneCountriesPromise;
    } catch (ex) {
      countriesex = ex;
    }

    let phoneCountry = null;
    if (countries) {
      if(countryValue && country)
        phoneCountry = countries.find(c => c.value === countryValue && c.category === country);
      else if (countryValue)
        phoneCountry = countries.find(c => c.value === countryValue);
      else
        phoneCountry = countries.find(c => c.category === country);
    }
    if (!phoneCountry)
      LoggerProvider.exception(this, countriesex, LoggerEvent.ComponentException, 'Failed to get phone country ' + country + ' for login component');

    return phoneCountry;
  }

  async setValue(value, country = null) {
     if (value && value.indexOf('@') === -1) {
      if(this.newInputField) {
        this.newInputField.formControl.value = ' ';
        this.newInputField.formControl.setValue(' ');

        this.hasPhoneNumber = true;
        const pos = value.indexOf('-');
        if (pos > 0) {
          this.setValuesToPhoneFields(value.substr(pos + 1), country);
          if (!country) {
            const countryValue = value.substr(0, pos);
            const phoneCountry = await this.getPhoneCountry(null, countryValue);
            if (phoneCountry){
            country = phoneCountry.category;
            this.setValuesToPhoneFields(value.substr(pos + 1), country);
            }
          }
        }
        else if (country) {
          let origValue = this.newInputField.formControl.value;
          const phoneCountry = await this.getPhoneCountry(country);
          if (phoneCountry && value.indexOf(phoneCountry.value) === 0)
            value = value.substr(phoneCountry.value.length);

          if (origValue !== this.newInputField.formControl.value) // if value has changed meanwhile don't set the value anymore
            return;

          this.newInputField.formControl.value = value;
          this.newInputField.formControl.setValue(value);
        }
        this.setCountryPhone(country);
      }
     }
     else if(value)
      this.newInputField.formControl.setValue(value);
   }

  setCountry(phoneInfo) {
    // Regular configuration with phone auto-formatting enabled.
    if (!phoneInfo.isValid) {
      this.setInvalidPhoneNumber();
    }
    if (phoneInfo.phone) {
      this.phone = phoneInfo.phone;
      this.setValuesToPhoneFields(this.phone);
    }
    if(phoneInfo.country){
      this.selectedCountry = phoneInfo.country;
    } else if(phoneInfo){
      this.selectedCountry = phoneInfo;
    }
    this.triggerChange();
  }

  getCountry() {
    return this.selectedCountry;
  }

  getCountryPrefix() {
    return this.getCountryPhonePrefix();
  }

  checkPhoneNumber(value) {
    const cleanValue = this.getCleanPhoneNumber(value);

    if (this.validatePhoneRegex(cleanValue) || this.utils.isNumber(cleanValue) || this.isPhoneOnly)
      this.hasPhoneNumber = true;
    else
      this.hasPhoneNumber = false;
  }

  getCleanPhoneNumber(value) {
    let cleanValue = value;

    if (cleanValue)
      cleanValue = this.utils.cleanPhoneNumber(cleanValue);

    return cleanValue;
  }

  validatePhoneRegex(value): boolean {
    return new RegExp(PATTERNS.PHONE).test(value) ;
  }

  changeValue(ev) {
    let hasPhoneNumber = this.hasPhoneNumber;
    const value = ev.target ? ev.target.value : ev.value;
    this.checkPhoneNumber(value);

    if (this.hasPhoneNumber !== hasPhoneNumber) {
      this.formGroup.controls.input.updateValueAndValidity();
      window.setTimeout(() => {
        if (this.newInputPhone && this.newInputPhone.input && this.newInputPhone.input.inputElemt) {
          this.newInputPhone.input.inputElemt.nativeElement.focus()
        } else if (this.newInputField && this.newInputField.inputElemt) {
          this.newInputField.inputElemt.nativeElement.focus()
        }
      }, 50);
    }
    this.newInputField.formControl.setValue(value);
    if (this.changeTimeout)
      window.clearTimeout(this.changeTimeout);
    this.changeTimeout = window.setTimeout(() => {
      this.triggerChange();
    }, 200);
  }

  // changeCountry(ev) {
  //   this.selectedCountry = ev;
  //   this.triggerChange();
  //   //this.authProvider.setUserCountry(ev, true, true);
  // }

  triggerChange() {
    if (this.changeTimeout)
      window.clearTimeout(this.changeTimeout);
    this.changeTimeout = null;
    this.ionChange.emit();
  }

  static convertCountryPrefix(phoneCountries, countryPrefix, fallbackCountry) {
    const countries = phoneCountries.filter((country) => (country.value === countryPrefix.toString()));
    if (countries && countries.length > 0) {
      if (countries.length > 1 && countries.find((country) => (country.category === fallbackCountry)))
        return fallbackCountry;
      else if (countries[0].value === 1)
        return 'US';
      else if (countries[0].category === 'GB')
        return 'UK';
      else
        return countries[0].category;
    }
    return null;
  }

  clickInput() {
      if(this.newInputField && this.newInputField.formControl.value){
        this.newInputField.formControl.value = this.newInputField.formControl.value.trim();
      }
  }


  inputBlur(){
    this.ionBlur.emit();
  }

  canAdjustPhoneNumber =() => {
    return this.autoAdjustPhoneNumber &&
    this.hasPhoneNumber && this.newInputField &&
    this.newInputField.select && this.newInputField.formControl && this.newInputField.formControl.value;
  }

  checkPhoneNumberNeedsFixing = ()=>{
    let inputFieldValue = this.newInputField.formControl.value.trim();
    return inputFieldValue.substr(0, 1) === '+' || inputFieldValue.substr(0, 2) === '00';
  }


  getBiometricsIconName() {
    return this.isFaceIdEnabled ? 'custom-icon-faceid' : 'custom-icon-touchId'
  }

  getBiometricsIconVisibility() {
    return this.biometricsEnabled ? 'visible' : 'hidden';
  }

  touchBiometrics() {
    this.hideError = true;
  }

  finishBiometrics() {
    window.setTimeout(() => {
      if (!this.pendingBiometrics)
        this.hideError = false;
    }, 500);
  }

  startBiometrics(event) {
    // this.pendingBiometrics = true;
    // this.hideError = true;
    // // callback when biometrics is finished
    // this.biometrics.emit((result) => {
    //   this.pendingBiometrics = false;
    //   if (!result)
    //     this.hideError = false;
    // });
    this.biometrics.emit(event);
  }

  getErrorMessagePhoneKey(){
    if(this.phoneLibNumberError){
      return 'form.phone.phoneTypeError';
    }else if(this.isPhoneOnly){
      return 'page.registrationFinishPage.invalidPhoneNumberMessage';
    } else{
      return 'form.signInForm.phoneEmail.phoneEmailRegex';
    }
  }

  setValuesToPhoneFields(phoneNumber, country=""){
    this.newInputField.formControl.value = phoneNumber;
    this.newInputField.formControl.setValue(phoneNumber);
    if(country && country !== "" && this.newInputField.select){
      this.newInputField.select.setValue(country);
    }

    this.setValuePhone(phoneNumber);
  }

  setInvalidPhoneNumber(){
    this.formGroup.controls.input.setErrors({'incorrect': true})
  }

  initParams() {
    this.params = {
      header: this.translate.instant('page.registrationStep2Page.selectCountryCode'),
      placeholder: this.translate.instant('page.languagePage.countrySearch'),
      useIcons: true,
      itemFieldIcon: 'category',
      itemFieldIconPrefix: 'custom-icon-country-',
      itemFieldSelectedText: 'category',
      itemFieldValue: 'category',
      itemsPromise: this.formProvider.getPhoneNumberCountriesRegistration(true),
      pickerId: "phonePickerRegisterationStepUser", //pass pickerid to selectpickerpage,
      favoritePromise: null,
      onSelect: async(country) => {
        if (country && country.isBlacklistedOTP)
          RmtPopupComponent.showExceptionWithLogTranslation(this, null, 'page.phoneVerificationPage.countryPhoneNotAvailMessage');
        else {
          const countryValue = country[this.params.itemFieldValue];
          this.select.setValue(countryValue);
          this.routeProvider.pop();
        }
      }
    };
  }

  async initCountries() {
    const countries = await this.resourceProvider.getAllCountries();
    this.countries = JSON.parse(JSON.stringify(countries));
    this.countries.forEach(country => {
      country.CountryCode = country.CountryCode.trim() + "-";
    });
  }

  async ngAfterViewInitPhone() {
    this.initParams();
    this.setDefault = false;
    await this.initCountries();

    if (this.inputCountry && this.inputCountry.value && this.select)
      this.select.setValue(this.inputCountry.value);
    else {
      const timeout = window.setTimeout(() => {
        this.setDefault = false;
      }, 100);
      this.select && await this.select.setValue(APP_CONFIG.region.defaultCountryFrom);
      window.clearTimeout(timeout);
    }
    this.setDefault = true;
  }

  ngOnChanges() {
  if(this.hasPhoneNumber) {
  const isFocused = (this.input && this.input.inputElemt && document.activeElement === this.input.inputElemt.nativeElement) ? true : false;
   if (this.formGroup && this.formGroup.controls && this.formGroup.controls.input)
   this.formDisableCountry = this.formGroup.controls.input.disabled;

   if(this.formGroup.invalid && this.formGroup.touched && !isFocused)
      this.hideError = false;
    }
  }

  getValuePhone() {
    return this.phone;
  }

  setValuePhone(phone) {
    this.setPhone(phone);
  }

  setPhone(phone) {
    this.phone = phone;
    this.newInputField.setValue(phone);
  }

  setCountryPhone(country) {
    this.selectedCountry = country;
    this.select.setValue(country);
  }

  getCountryPhone() {
    return this.selectedCountry;
  }

  getCountryPhonePrefix() {
    return this.selectedCountryPrefix;
  }
  changePhone(ev) {
    this.isNumberValidating = true;
    this.formGroup && this.formGroup.markAsTouched();
    this.phone = ev.value;
    if (this.changeTimeout)
      window.clearTimeout(this.changeTimeout);
    if (this.formGroup && this.formGroup.controls && this.formGroup.controls.input) {
      this.formGroup.controls.input.updateValueAndValidity({emitEvent: false});
    }
    if (this.formGroup.valid)

      this.hideError = true;
    this.changeTimeout = window.setTimeout(() => {
      this.triggerPhoneChange(false);
    }, 200);
  }

  async changeCountry(ev) {
    this.selectedCountry = ev;
    if (this.inputCountry)
      this.inputCountry.value = ev;
    this.triggerPhoneChange(true);
    this.formGroup && this.formGroup.get('input').markAsTouched();
    this.formGroup &&  this.formGroup.get('input').updateValueAndValidity();
    // Calling country feature api to update country setting. SN has login with PIN/passcode
    if(this.selectedCountry == Region.SN) {
      await this.authProvider.setUserCountry(this.selectedCountry, true, true, false, false, false);
      await this.utils.refreshCountryFeatures()
      await this.registerProvider.setIsPINOnlyRegistration();
      await this.loginProvider.setIsPINEnabledCountry();
      if(this.loginProvider.isPINEnabledCountry) this.setPhoneOnly()
      this.triggerChange();
    }
  }

  changePhoneCountry(ev) {
    if (this.selectedCountry !== ev.value)
      this.changeCountry(ev.value);
  }

  removePrefix(phoneWithPrefix) {
    let phoneWithoutPrefix = phoneWithPrefix.split(' ').slice(1).join('');
    if (phoneWithoutPrefix == '') {
      return this.removeNumberSpecialChars(phoneWithPrefix)
    }
    return phoneWithoutPrefix;
  }

  triggerPhoneChange(isCountryChanged) {
    if (this.changeTimeout)
      window.clearTimeout(this.changeTimeout);
    this.changeTimeout = null;
    let prefix = '';
    if(this.countries) {
      const findSelectedCountry = this.countries.filter(country => country.NameAbbrev === this.selectedCountry)[0]
      if(findSelectedCountry && findSelectedCountry.CountryCode) prefix = findSelectedCountry.CountryCode;
    }
    this.selectedCountryPrefix = prefix;
    window.setTimeout(() => {
    this.validateAndParsePhoneNumber(isCountryChanged, prefix);
    }, 200);
  }

  // static convertCountryPrefix(phoneCountries, countryPrefix, fallbackCountry) {
  //   const countries = phoneCountries.filter((country) => (country.value === countryPrefix.toString()));
  //   if (countries && countries.length > 0) {
  //     if (countries.length > 1 && countries.find((country) => (country.category === fallbackCountry)))
  //       return fallbackCountry;
  //     else if (countries[0].value === 1)
  //       return 'US';
  //     else if (countries[0].category === 'GB')
  //       return 'UK';
  //     else
  //       return countries[0].category;
  //   }
  //   return null;
  // }

  focus() {
    this.newInputField.inputElemt.nativeElement.focus();
  }

  checkPreKey(ev) {
    if (this.hasPhoneNumber) {
      if (ev.key === '.' || ev.key === ',')
        ev.preventDefault();
      else if (this.utils.checkNonDgigitCharacters(ev.key) && this.isPhoneOnly && ev.keyCode !== 8) {
        ev.preventDefault();
      }
      else if (this.validateValue(ev)) {
        ev.value = this.removeNumberSpecialChars(ev.value);
        this.lastValue = ev.value;
      }
    }
  }

  changePostKey(ev) {
    if (this.hasPhoneNumber) {
      if(ev.value && (ev.value.includes('@') || this.utils.checkNonDgigitCharacters(ev.value)) && !this.isPhoneOnly) {
        this.hasPhoneNumber = false;
        this.changeValue(ev);
        return;
      }
      if (this.lastValue !== undefined && (!this.validateValue(ev) || (ev.data && !ev.value)))
        ev.value = this.lastValue;
      this.changePhone(ev);
      if((ev.value === "" || ev.value === undefined) && !this.isPhoneOnly) {
        this.hasPhoneNumber = false;
        this.resetFormValidationForInput();
        this.animatePassword.emit();
      }
    } else if(ev.value && this.utils.checkDigitRegex(ev.value)) {
      this.hasPhoneNumber = true;
      this.changePhone(ev);
    } else {
      this.changeValue(ev)
    }
  }

  resetFormValidationForInput() {
    this.formGroup.get('input').setValidators((control: FormControl) => {
      let pattern: any = PATTERNS.EMAIL;
      if (this.hasPhoneNumber)
        pattern = PATTERNS.PHONE.toString();
      const error = Validators.pattern(pattern)(control);
      if (error)
        return error;
      return Validators.required(control);
    });
  }

  onFocus(ev) {
    this.focus();
  }

  removeNumberSpecialChars(phoneWithSpecialChars){
    let phoneWithoutSpaces = phoneWithSpecialChars.replace(/[^0-9]*/g, '');
    return phoneWithoutSpaces;
  }

  validateValue(ev) {
    if(ev.value==undefined ){
      return false;
    }

    if (ev.value && ev.value.length === 0)
      return true;

    let reg = new RegExp('^[0-9]+$');
    let cleanValue = this.utils.cleanPhoneNumber(ev.value);
    return reg.test(cleanValue);
  }

  checkError() {
    return this.formGroup.controls && this.formGroup.touched && !this.formGroup.valid;
  }

  onBlur(ev) {
    if(this.hasPhoneNumber && !ev.value && this.formGroup.controls && this.formGroup.controls.input) {
      this.formGroup.controls.input.markAsTouched();
      // this.formGroup.controls.setErrors({'incorrect': true});
      this.hideError = false;
      this.formGroup.controls.input.setErrors({'incorrect': true});
    }else if(this.hasPhoneNumber && ev.value){
      this.inputBlur();
    }
  }

  getDynamicClass() {
    const isPhoneError = this.formGroup && !this.formGroup.valid && this.formGroup.get('input') && !this.formGroup.get('input').pristine;
    if ((this.hasPhoneNumber || this.isPhoneOnly) && (!this.hideError || isPhoneError)) {
      return 'rmt-country rmt-phone-fields-error'
    }
    else if (this.hasPhoneNumber || this.loginProvider.isPINEnabledCountry) {
      return 'rmt-country';
    }
    else {
      return '';
    }
  }

  getErrorMessageKey() {
    // if(this.errorMessageKey)
    //   return this.errorMessageKey;

    return 'page.phoneVerificationPage.mobilePhoneNumberRegex';
  }

  validateAndParsePhoneNumber(isCountryChanged: boolean, prefix: string) {
    try {
      const numberToParse: string = this.phone ? this.phone :
        (this.input && this.input.formControl && this.input.formControl.value ? this.input.formControl.value : "");

      if (numberToParse.length < 1) {
        return;
      }


      const phoneParam = {
        phone: this.phone,
        selectedCountry: this.selectedCountry,
        numberToParse: numberToParse,
        setPhone: (phone) => this.setPhone(phone),
        setSelectedCountryFromParsedNumber: (parsedNumber, countryCode) => this.setSelectedCountryFromParsedNumber(parsedNumber, countryCode),
        setCountry: (phoneInfo) => this.setCountry(phoneInfo),
        select: this.select
      };

      const {isValid, isCountryChangedPhone}: any = this.phoneProvider.validateAndParsePhoneNumber(isCountryChanged, prefix, phoneParam);

      this.hideError = isValid;

      this.ionChange.emit({
        isValid: isValid,
        toggleErrorMessage: () => {
          this.hideError = !this.hideError;
        }
      });

      // Emit event with the validation result and formatted number
      this.setCountry({
        isValid: isValid,
        phone: this.phone,
        country: this.selectedCountry,
        prefix: prefix,
        isCountryChanged: isCountryChanged
      })
    } catch(error) {
      // Generally thrown by this.phoneUtil.parseAndKeepRawInput
      // when the input phone number cannot be parsed correctly by the lib.
      LoggerProvider.info(this, LoggerEvent.InvalidPhoneNumber, (error as Error).message);
      this.hideError = false;

      this.ionChange.emit({
        isValid: false,
        toggleErrorMessage: () => {
          this.hideError = !this.hideError;
        }
      });
    }
  }

  private setSelectedCountryFromParsedNumber(parsedNumber: any, countryCode) {
    const regionCode = this.phoneUtil.getRegionCodeForNumber(parsedNumber);
    // Handle edge case for +44. Ria=UK, Googlelib=GB.
    this.selectedCountry = regionCode === "GB" ? "UK" : regionCode;
    if(!regionCode)
      this.selectedCountry = countryCode;
    this.setCountryPhone(this.selectedCountry);
  }

  getInputErrorMessage() {
    if(!this.hasPhoneNumber)
      return this.translate.instant('form.signInForm.phoneEmail.phoneEmailRegex');
    else
      return '';
  }

  getInputClass() {
    if(this.isPhoneOnly || this.hasPhoneNumber || this.loginProvider.isPINEnabledCountry) {
      return 'input-phone-width';
    } else {
      return 'input-email-width';
    }
  }

  isPhoneField() {
    return this.hasPhoneNumber || this.isPhoneOnly;
  }
}


// WEBPACK FOOTER //
// ./src/components/rmt-login/rmt-login.ts